// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"543":"81cf21c5","754":"ef4c2106"}[chunkId] + ".chunk.css";
};